/**
 * Utility Objects
 *
 */

import * as utils from "@sharedJS/utils";

let socialMediaButton;
let openSocialWindow;

function init() {
	socialMediaButton = $(".js-social-media");

	// Dependencies
	openSocialWindow = utils.openWindow;

	socialMediaButton.click(function () {
		openSocialWindow($(this).data("url"), Math.random(), $(this).data("height"), $(this).data("width"));
	});
}

export { init };
